const { billetType } = require('@transfeeradev/api-enums');

module.exports = class GetTypeService {
  static get(barcode) {
    if (typeof barcode !== 'string') {
      throw new Error('barcode need to be a string');
    }

    if (+barcode[0] === 8) {
      return billetType.COLLECTION;
    }

    return billetType.SIMPLE;
  }
};
